export const ATTRIBUTE_MODELS = [
  { id: 0, key: 'CONVERSATION' },
  { id: 1, key: 'CONTACT' },
  { id: 2, key: 'OPPORTUNITY' },
];

export const ATTRIBUTE_MODEL_KEY_BY_ID = {
  0: 'conversation_attribute',
  1: 'contact_attribute',
  2: 'opportunity_attribute',
};

export const ATTRIBUTE_TYPES = [
  { id: 0, key: 'TEXT' },
  { id: 1, key: 'NUMBER' },
  { id: 2, key: 'CURRENCY' },
  { id: 3, key: 'PERCENT' },
  { id: 4, key: 'LINK' },
  { id: 5, key: 'DATE' },
  { id: 6, key: 'LIST' },
  { id: 7, key: 'CHECKBOX' },
];
